export default "__VITE_ASSET__494496a7__"